import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import { EMPTY_ARRAY, EMPTY_OBJECT } from 'Utils/stableDefaults'

function ImagesDragPreview({ images = EMPTY_ARRAY, imageProps = EMPTY_OBJECT, imageComponent: Component }) {
  return (
    <Fragment>
      {images.slice(0, 3).map((image, i) => (
        <div
          key={image.id}
          style={{
            zIndex: images.length - i,
            transform: `rotateZ(${-i * 2.5}deg) translateY(${-i * 120}px)`,
            maxWidth: 219,
          }}
        >
          <Component url={image.url} imageProps={{ ...image, ...imageProps }} />
        </div>
      ))}
    </Fragment>
  )
}

ImagesDragPreview.propTypes = {
  images: PropTypes.array,
  imageProps: PropTypes.object,
  imageComponent: PropTypes.func.isRequired,
}

export default ImagesDragPreview
